import { api } from './index';

/**
 * Fetches all quote templates for a specific organization.
 * @param {object} requestParams
 * @param {number} requestParams.orgId - The id of the org to get the template from.
 * @returns {Promise} - the request
 */
export const fetchQuoteTemplates = async ({ orgId }) => {
  return api.get(`/api/organization/${orgId}/templates/quotes`);
};

export const createQuoteFromLead = async ({
  isTemplate = false,
  orgId,
  templateId,
  ...payload
}) => {
  const baseUrl = `/api/organization/${orgId}/quotes`;
  if (isTemplate) {
    return api.post(
      `${baseUrl}/from-template/${templateId}`,
      { ...payload, template_id: templateId },
    );
  }
  return api.post(baseUrl, payload);
};
